<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">团长分销管理</div>
    </div>
    <group-list></group-list>
  </div>
</template>

<script>
import GroupList from './components/groupList.vue'
export default {
  components:{
    GroupList
  }
}
</script>

<style scoped lang="less">
.header{
  display: flex;
  justify-content: space-between;
  .title{
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/groupLeaderDistribution.vue